






































import {Component, Watch} from 'vue-property-decorator';
import {Call, Sync} from 'vuex-pathify';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {Mixins} from 'vue-property-decorator';
import {FeathersVuexFindAll, serviceAsDataLayerProduct} from '@/utils';
import {nil} from '@/common';
import KeyedImagesMixin from '@/mixins/KeyedImagesMixin.vue';
import TierSelector from '@/components/Pages/Booking Flow/TierSelector.vue';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import {groupBy, uniq, sortBy} from 'lodash';

@Component({
    components: {TierSelector},
})
export default class BookingChooseService extends Mixins(CurrencyMixin, KeyedImagesMixin, ScreenSizeMixin) {
    @Sync('booking/tier') public tier!: any;
    @Sync('booking/serviceType') public serviceType!: string;
    @Call('booking/setServices') public setServices!: (services: any[]) => any[];
    @Sync('booking/category') private category!: any;
    @Sync('booking/services') private services!: any[];
    @Sync('booking/step') private step!: number;
    private loadedServices: any[] = [];
    private loading = false;
    private showDescription = false;
    public mounted() {
        if (nil(this.tier)) {
            this.showDescription = true;
        }
        this.getServices();
        this.step = 3;
        /*if(nil(this.category)){
            this.step = 2;
        } else {
            this.$router.go(-1);
        }*/
    }
    public async getServices() {
        this.loadedServices = [];
        this.loading = true;
        if (!nil(this.tier)) {
            const response = await FeathersVuexFindAll(this.$FeathersVuex.Purchasable, {
                query: {
                    service: true,
                    // category: this.category._id,
                    tier: this.tier._id,
                },
            });
            this.loadedServices = response.filter((x) => !nil(x.category) && x.category === this.category._id);
        }
        this.loading = false;
    }
    private addToCart(newService: any) {
        window.dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    products:serviceAsDataLayerProduct(newService)
                }
            }
        });
        this.services = [...this.services, newService];
    }

    private removeFromCart(id: string) {
        window.dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    products:serviceAsDataLayerProduct(this.services.filter(x=>x._id===id))
                }
            }
        });
        const removedServices = this.services.filter((x) => x._id !== id);
        this.setServices(removedServices);
    }
    public imageSource(service) {
        const [imageModel] = service.imageModels;
        return nil(imageModel) ? null : imageModel.file;
    }
    private scheduleOrder() {
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                actionField:{'step':3},
                products:this.services.map(serviceAsDataLayerProduct)
            }
        });
        this.step++;
    }

    private get isLarge() {
        return this.isSM(true);
    }
    private get stickyStyle() {
        if (!this.isMD(true)) { return ''; }
        const anb = document.querySelector('.app-nav-bar');
        if (nil(anb)) { return ''; }
        return `top:${anb.clientHeight + 24}px`;
    }
    public get loaderSize() {
        return this.largestDimension() / 4;
    }
    public get groupedServices() {
        const grouped = {};
        for (const service of sortBy(this.loadedServices, 'serviceTypes.length').reverse()) {
            let key = service.serviceTypeModels.length === 1 ? service.serviceTypeModels[0].name : service.serviceTypeModels.map((x) => x.name).join();
            if (key.indexOf(',') > -1) {
               const arrkey = key.split(',');
               const last = arrkey.pop();
               key = `${arrkey.join(', ')} and ${last}`;
            }
            if (nil(grouped[key])) {
                grouped[key] = [];
            }
            grouped[key].push(service);
        }
        return grouped;
    }
    @Watch('tier')
    public onTierChanged(value: any, oldValue: any) {
        this.getServices();
        this.showDescription = false;
    }
}
